import { AnalyticsContext } from '@carvana/eventable-clickstream';
import Tooltip from '@carvana/showroom-tooltip';
import { Clickable } from '@carvana/vdp-components';
import { useContext } from 'react';
import { getPurchaseStatus } from '@/SearchResults/ResultTile/ResultTile.helpers';
import Tag from '@/SearchResults/ResultTile/Tags/Tag';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import { useVehicleContext } from '~/contexts/VehicleContext';
import { Vehicle } from '~/contracts';
import { VehicleTag } from '~/contracts/Vehicle';
import { ViewAllButton } from './Tags.style';

const findGreatDeal = (tag: VehicleTag) => tag?.tagId === 104;

export const useGreatDealTag = (
  vehicle: Partial<Vehicle>
): VehicleTag | null => {
  return vehicle?.vehicleTags?.find(findGreatDeal) ?? null;
};

type OwnProps = {
  withPriceDrop: boolean;
};

const GreatDealTag = ({ withPriceDrop }: OwnProps) => {
  const { vehicle } = useVehicleContext();
  const { trackEvent } = useContext(AnalyticsContext);
  const { setAppliedFilters } = useContext(AppliedFiltersContext);

  const { isLocked, isOnHold } = getPurchaseStatus(vehicle);
  const greatDeal = useGreatDealTag(vehicle);

  if (
    isLocked ||
    isOnHold ||
    vehicle?.vehiclePurchaseType === 'Reservable' ||
    greatDeal == null
  ) {
    return null;
  }

  const [description] = greatDeal.tagDescription.split('<br><br>');

  return (
    <Tooltip
      direction="bottom-start"
      display={{
        width: 235,
        contentOffsetX: withPriceDrop ? -40 : 0,
        arrowOffsetX: withPriceDrop ? 40 : 0
      }}
      content={
        <>
          <p className="t-body-s text-grey-2">{description}</p>
          <p className="mt-16 text-grey-3">
            * Savings amount based on the difference between Kelley Blue
            Book&reg; Typical Listing Price and the current Carvana listing
            price, not including tax, title, registration, or delivery fees.
            Savings amounts are updated daily.
          </p>

          <Clickable
            className="min-h-unset mt-16 w-full"
            data-analytics-id={null}
            element={ViewAllButton}
            onClick={e => {
              e.preventDefault();
              trackEvent('Clicked Great Deal ToolTip CTA');
              setAppliedFilters({ tagIds: ['104'] });
            }}
          >
            View All
          </Clickable>
        </>
      }
      title={greatDeal.tagName}
    >
      <div
        data-analytics-id="Great Deal Tooltip"
        onClick={e => e.preventDefault()}
        data-qa="great-deal-badge"
      >
        <Tag text={greatDeal.tagName} bgColor="bg-blue-4" />
      </div>
    </Tooltip>
  );
};

export default GreatDealTag;
